export var extractRevisionAndPath = function extractRevisionAndPath(url, assetsPackageId) {
  var regex = new RegExp("".concat(assetsPackageId, "/(.+?)\\?revision=(\\d+)"));
  var match = (url === null || url === void 0 ? void 0 : url.match) && url.match(regex);
  return match ? {
    path: match[1],
    revision: parseInt(match[2], 10)
  } : null;
};